module.exports = __webpack_public_path__ + "img/3.efcbb94f.jpg";